import { useMutation, useQueryClient } from '@tanstack/react-query'

import { updatePreferredLanguage } from './settings.service'

export const usePreferredLanguageUpdate = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updatePreferredLanguage,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['users'],
      })
    },
  })
}
